<template>
  <div
    class="international-pay-component"
    v-loading="loading"
  >
    <div class="container">
      <div class="i18n-module">
        <el-select
          class="i18n-select"
          v-model="i18n"
        >
          <el-option
            v-for="item in i18nList"
            :key="item.key"
            :label="item.label"
            :value="item.key"
          />
        </el-select>
      </div>

      <international-pay-title
        :order="order"
        :i18n="i18n"
      />

      <international-pay-form
        ref="payForm"
        :form="form"
        :rules="rules"
        :i18n="i18n"
      />

      <template v-if="order.payOrderView.versions && order.payOrderView.versions.length">
        <agreement
          :versions="order.payOrderView.versions"
          :serialNumber="order.payOrderView.serialNumber"
          :studentId="order.studentId"
          :checked.sync="checkedAgreement"
          :i18n="i18n"
        ></agreement>
      </template>

      <div class="pay-module">
        <span
          class="pay-now"
          @click="pay"
        >立即支付</span>
      </div>

      <div class="footer-imgs">
        <img src="@/assets/images/order/pay-footer-1.jpg" />
        <img src="@/assets/images/order/pay-footer-2.jpg" />
      </div>

    </div>
  </div>
</template>

<script>
import internationalPayTitle from './components/internationalPayTitle'
import internationalPayForm from './components/internationalPayForm'
import agreement from './components/agreement'
import { I18n } from './config'

export default {
  mixins: [],
  components: {
    internationalPayTitle, internationalPayForm, agreement
  },
  data() {
    return {
      loading: true,
      i18n: 'HK',
      i18nList: [{
        key: 'HK',
        label: '繁體中文'
      }, {
        key: 'CN',
        label: '简体中文'
      }],
      form: {
        cardNo: '',
        cvv2: '',
        cardExpire: '',
        issuingBank: '',
        firstName: '',
        lastName: '',
        address: '',
        city: '',
        country: 'HK',
        state: '',
        zip: '',
        email: '',
        phone: ''
      },
      rules: {
        cardNo: [],
        cvv2: [],
        cardExpire: [],
        issuingBank: [],
        firstName: [],
        lastName: [],
        address: [],
        city: [],
        country: [],
        state: [],
        zip: [],
        email: [],
        phone: []
      },
      orderInfo: this.$route.params,
      order: {
        payOrderView: {}
      },
      checkedAgreement: false,
    }
  },
  created() {
    this.getOrderDetail()
    this.initRules()
  },
  methods: {
    TS(key) {
      return I18n(this.i18n, key)
    },
    initRules() {
      const rulesMap = {
        cardNo: [
          { required: true, message: this.TS('Card_No_Required'), trigger: 'blur' },
          { max: 200, message: this.TS('Card_No_Max'), trigger: 'blur' }
        ],
        cvv2: [
          { required: true, message: this.TS('Cvv2_Required'), trigger: 'blur' },
          { min: 3, max: 3, message: this.TS('Cvv2_Max'), trigger: 'blur' }
        ],
        cardExpire: [
          { required: true, message: this.TS('Card_Expire_Required'), trigger: 'change' }
        ],
        issuingBank: [
          { required: true, message: this.TS('Issuing_Bank_Required'), trigger: 'blur' },
          { max: 255, message: this.TS('Issuing_Bank_Max'), trigger: 'blur' }
        ],
        firstName: [
          { required: true, message: this.TS('First_Name_Required'), trigger: 'blur' },
          { max: 100, message: this.TS('First_Name_Max'), trigger: 'blur' }
        ],
        lastName: [
          { required: true, message: this.TS('Last_Name_Required'), trigger: 'blur' },
          { max: 50, message: this.TS('Last_Name_Max'), trigger: 'blur' }
        ],
        address: [
          { required: true, message: this.TS('Address_Required'), trigger: 'blur' },
          { max: 500, message: this.TS('Address_Max'), trigger: 'blur' }
        ],
        city: [
          { required: true, message: this.TS('City_Required'), trigger: 'blur' },
          { max: 100, message: this.TS('City_Max'), trigger: 'blur' }
        ],
        country: [
          { required: true, message: this.TS('Country_Required'), trigger: 'change' },
        ],
        zip: [
          { required: true, message: this.TS('Zip_Required'), trigger: 'change' },
          { max: 100, message: this.TS('Zip_Max'), trigger: 'blur' }
        ],
        email: [
          { required: true, message: this.TS('Email_Required'), trigger: 'change' },
          { max: 200, message: this.TS('Email_Max'), trigger: 'blur' }
        ],
        phone: [
          { required: true, message: this.TS('Phone_Required'), trigger: 'change' },
          { max: 50, message: this.TS('Phone_Max'), trigger: 'blur' }
        ]
      }
      for (let i in this.rules) {
        this.rules[i] = rulesMap[i]
      }
    },
    getOrderDetail() {
      this.axios({
        method: 'post',
        url: '/gw/order-rest/api/order_rest/pay/pc/detail',
        params: this.orderInfo
      }).then(res => {
        if (res.data.code === 200) {
          // 如果versions中含有vt ， 剔除即可，这个对前端没用，还会影响协议展示  
          const index = res.data.data.payOrderView.versions.indexOf('vt')
          if (index > -1) {
            res.data.data.payOrderView.versions.splice(index, 1)
          }
          this.order = res.data.data
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    pay() {
      this.$refs.payForm.validate((valid) => {
        if (valid) {
          if (!this.checkedAgreement && this.order.payOrderView.versions.length) {
            this.$alert(this.TS('Agree_Ag'))
            return
          }
          const cardExpire = this.form.cardExpire.split('-')
          this.form.cardExpireYear = cardExpire[0]
          this.form.cardExpireMonth = cardExpire[1]
          this.payApi()
        }
      })
    },
    payApi() {
      if (this.paying) return
      this.paying = true
      this.axios({
        method: 'post',
        url: '/gw/order-rest/api/order_rest/pay/instrument',
        params: {
          channel: 'ABROAD_ZMT',
          payOrderId: this.order.payOrderView.id,
          businessId: this.order.payOrderView.id,
          businessType: 'ORDER',
          source: 'PC',
          device: 'PC',
          url: location.origin + '/order/payResult',
          t: new Date().getTime(),
          abroadParam: JSON.stringify({
            ...this.form
          })
        }
      }).then(response => {
        let res = response.data
        if (res.code === 200) {
          let form = document.createElement('form')
          form.setAttribute('method', 'post')
          form.setAttribute('action', res.data.returnUrl)
          for (let key in res.data.params) {
            let hiddenField = document.createElement('input')
            hiddenField.setAttribute('type', 'hidden')
            hiddenField.setAttribute('name', key)
            hiddenField.setAttribute('value', res.data.params[key])
            form.appendChild(hiddenField)
          }
          document.body.appendChild(form)
          form.submit()
        }
        this.paying = false
      }).catch(() => {
        this.paying = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.international-pay-component {
  padding: 20px 0;
  .i18n-module {
    text-align: right;
    .i18n-select {
      width: 110px;
    }
  }
  .pay-module {
    text-align: center;
    margin: 60px 0 40px;
    .pay-now {
      display: inline-block;
      height: 40px;
      line-height: 40px;
      cursor: pointer;
      background-color: #ff6422;
      color: #fff;
      border-radius: 20px;
      width: 144px;
      font-size: 16px;
    }
  }
  .footer-imgs {
    margin-bottom: 100px;
    img {
      display: inline-block;
      height: 110px;
      margin-right: 58px;
    }
  }
}
</style>
